<template>
  <div class="certificate-page">
    <div class="state-card">
      <div v-if="loading" class="loader"></div>
      <i v-else-if="error" class="ri-error-warning-line error-icon"></i>
      <i v-else class="ri-file-pdf-2-line success-icon"></i>

      <p>{{ statusMessage }}</p>

      <div class="actions">
        <f-button v-if="error" type="primary" @click="openPreview">
          إعادة المحاولة
        </f-button>
        <f-button type="secondary" @click="goBack">العودة للمسح</f-button>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCertificate } from "@/Services/CertificateService";
import { previewStoredFile } from "@/Services/StoredFileService";

export default {
  data() {
    return {
      loading: true,
      error: false,
      licenseFile: "",
      fileUrl: "",
      fileName: "",
      certificateId: "",
    };
  },
  computed: {
    statusMessage() {
      if (this.loading) return "جاري فتح الشهادة...";
      if (this.error) return "فشل في فتح الشهادة.";
      return "تم فتح الشهادة في نافذة جديدة.";
    },
  },
  mounted() {
    this.certificateId = this.$route.params.id;
    this.openPreview();
  },
  methods: {
    goBack() {
      this.$router.push("/qr-reader");
    },
    async openPreview() {
      this.loading = true;
      this.error = false;

      try {
        const cert = await fetchCertificate(this.certificateId);

        if (!cert.fileUrl) {
          this.error = true;
          return;
        }

        this.licenseFile = cert.licenseFile;
        this.fileUrl = cert.fileUrl;
        this.fileName = cert.fileName;
        await previewStoredFile(cert.fileUrl, cert.fileName);
      } catch (err) {
        console.error("Failed to open certificate:", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.certificate-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--light-gray);
  padding: 24px;
}

.state-card {
  width: min(100%, 420px);
  background: var(--white);
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.error-icon {
  font-size: 48px;
  color: var(--red-color);
}

.success-icon {
  font-size: 56px;
  color: var(--primary-color);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.actions :deep(.btn) {
  width: 100%;
}

.loader {
  width: 44px;
  height: 44px;
  border: 4px solid var(--light-gray3);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
